import PropTypes from 'prop-types';

import GlobalHeader from '@app/components/GlobalHeader';
import Authentication from '@app/containers/Authentication';

const propTypes = {
  children: PropTypes.node.isRequired,
};

function Payment({ children }) {
  return (
    <Authentication redirectToOnlyPathname={false}>
      <GlobalHeader />
      {children}
    </Authentication>
  );
}

Payment.propTypes = propTypes;

export default Payment;
